(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/expanded-systems/assets/expand-scoreboard-to-srow.js') >= 0) return;  svs.modules.push('/components/tipsen/expanded-systems/assets/expand-scoreboard-to-srow.js');
"use strict";


const {
  utils,
  expandToCombinations
} = svs.components.tipsen.expandedSystems;

const expandScoreboardToSrow = outcomes => {
  const sRows = expandToCombinations(...outcomes);
  return sRows;
};

const expandScoreBoardToSrowToHex = (outcomes, eventTypeId) => {
  const sRows = expandScoreboardToSrow(outcomes);
  const hexRows = utils.compressSROWToHex(sRows, {
    eventTypeId
  });
  return hexRows;
};
setGlobal('svs.components.tipsen.expandedSystems', {
  expandScoreboardToSrow,
  expandScoreBoardToSrowToHex
});

 })(window);